// The anonymous user's state: one JSON document in localStorage (spec §2.6).
import type { Status } from "../db/schema";

/** A learning goal (spec §2.2a): a subject you work on, with the resources you are using. */
export type Goal = { since: string; using: string[]; done: string[] }; // rec ids
export type LocalState = {
  marks: Record<string, Status>; // subject slug → status
  used: Record<string, string>; // rec id → date
  helpful: Record<string, true>; // comment ids marked helpful
  goals: Record<string, Goal>; // subject slug → goal
  days: Record<string, string[]>; // ISO date → subject slugs worked on that day
  lensesOn: Record<string, string[]>; // subject slug → lens slugs
  positions: Record<string, [number, number]>; // subject slug or @username → dragged position
  asked: Record<string, true>; // subject slug → "know a good one?" was dismissed or answered
  showGenerated: boolean;
  recent: string[]; // subject slugs, newest first
};

const KEY = "priorarcade:v1";

export const empty = (): LocalState => ({ marks: {}, used: {}, helpful: {}, goals: {}, days: {}, lensesOn: {}, positions: {}, asked: {}, showGenerated: true, recent: [] });

export function load(): LocalState {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as Partial<LocalState> & { tracking?: Record<string, true> };
      const s = { ...empty(), ...parsed };
      // v1.2 tracked subjects become goals (v1.3)
      for (const slug of Object.keys(parsed.tracking ?? {})) if (!s.goals[slug]) s.goals[slug] = { since: today(), using: [], done: [] };
      delete (s as { tracking?: unknown }).tracking;
      return s;
    }
  } catch {}
  return empty();
}

export function save(s: LocalState) {
  try {
    localStorage.setItem(KEY, JSON.stringify(s));
  } catch {}
}

export const isoDay = (d: Date) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const today = () => isoDay(new Date());
export const daysAgo = (n: number) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return isoDay(d);
};
